import { Component } from '@angular/core';

@Component({
  selector: 'ngx-messages',
  template: `<router-outlet></router-outlet>`,
})
export class MessagesComponent {
}
